import React, { PureComponent } from 'react';
import {
    View,
    PanResponder,
    Animated
} from 'react-native';
import {
    JDImage
} from '@jdreact/jdreact-core-lib';
import { pt } from '../../common/utils';

function _pos(x) {
    return x * 10 / pt(10);
}

/* 根据成绩计算 每一个星星的状态 0 空 0.5 半星 1 星 */
function getScore(score) {
    const list = [];

    let s = Math.round(score) / 2;

    for (let i = 0; i < 5; i++, s--) {
        list[i] = s <= 0 ? 0 : s === 0.5 ? 0.5 : 1;
    }

    return list;
}

/* 分数组件 小星星 */
class Star extends PureComponent {
    render() {
        const { type, style, color } = this.props;

        return (color === 'oriange'
            ? <JDImage source={ type === 0 ? img.star_empty : type === 1 ? img.ostar_full : img.ostar_half } style={ style } />
            : <JDImage source={ type === 0 ? img.star_empty : type === 1 ? img.star_full : img.star_half } style={ style } />);
    }
}

const pad = 20;

/* 分数组件 整体 */
export default class Stars extends PureComponent {
    constructor(props) {
        super(props);
        this.starWidth = this.props.size || 10; // 单位宽度 间隙 0.4 * sw
        this.width = new Animated.Value(0);
        this.index = 0;
        this._viewPanResponder = PanResponder.create({
            onStartShouldSetPanResponder: (evt, gestureState) => true,
            onStartShouldSetPanResponderCapture: (evt, gestureState) => true,
            onMoveShouldSetPanResponder: (evt, gestureState) => true,
            onMoveShouldSetPanResponderCapture: (evt, gestureState) => true,
            onPanResponderTerminationRequest: (evt, gestureState) => false,
            onShouldBlockNativeResponder: (evt, gestureState) => true,
            onPanResponderGrant: (evt, gestureState) => {

            },
            onPanResponderMove: (evt, gestureState) => {
                const lx = evt.nativeEvent.locationX;
                // 修复RN转H5评价组件事件失效

                const Mx = evt.nativeEvent.changedTouches[0].clientX - 45;

                this.setPos(Mx);
            },
            onPanResponderRelease: (evt, gestureState) => {
                // 0 -> pad+0.5sw -> pad+1.2sw -> pad+1.9sw -> ...
                const lx = evt.nativeEvent.locationX;

                const Mx = evt.nativeEvent.changedTouches[0].clientX - 45;

                this.setPos(Mx);
            },
            onPanResponderTerminate: (evt, gestureState) => {
                const lx = evt.nativeEvent.locationX;

                const Mx = evt.nativeEvent.changedTouches[0].clientX - 45;

                this.setPos(Mx);
            }
        });
    }

    render() {
        const { score = 0, onPress, color } = this.props;

        const sw = this.starWidth;

        this.width.setValue(pt(0.7 * sw * score - 0.2 * sw + pad));
        const style = {
            mask: {
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0)'
            },
            pan: {
                flexDirection: 'row',
                paddingLeft: pt(pad),
                width: pt(sw * 5 + sw * 0.4 * 4 + pad * 2),
                height: pt(sw),
                overflow: 'hidden'
            },
            star: {
                width: pt(sw),
                height: pt(sw),
                marginRight: pt(sw * 0.4),
                resizeMode: 'contain'
            }
        };

        if (onPress) {
            return (
                <View style={ style.pan }>
                    <View style={ { ...style.mask, ...style.pan } }>
                        {[0, 0, 0, 0, 0].map((x, i) => <Star style={ style.star } type={ x } key={ i } color={ color } />)}
                    </View>
                    <Animated.View style={ {
                        ...style.mask, ...style.pan, width: this.width
                    } }>
                        {[1, 1, 1, 1, 1].map((x, i) => <Star style={ style.star } type={ x } key={ i } color={ color } />)}
                    </Animated.View>
                    <View style={ style.mask } { ...this._viewPanResponder.panHandlers } />
                </View>
            );
        }

        return (
            <View style={ { flexDirection: 'row' } }>
                {getScore(score).map((x, i) =>
                    <Star style={ style.star } type={ x } key={ i } index={ i } color={ color } />
                )}
            </View>
        );
    }

    setPos(lx) {
        if (!lx && lx != 0) return;
        const x = _pos(lx);

        const sw = this.starWidth;

        let i = (x - pad + 0.5 * sw) / (0.7 * sw);

        i < 0 && (i = 0);
        i > 10 && (i = 10);
        i = Math.round(i);
        if (this.index != i) {
            this.width.setValue(pt(0.7 * sw * i - 0.2 * sw + pad));
            this.props.onPress(i);
            this.index = i;
        }
    }
}

const img = {
    star_full: require('./img/star-full.png'),
    star_half: require('./img/star-half.png'),
    ostar_full: require('./img/ostar-full.png'),
    ostar_half: require('./img/ostar-half.png'),
    star_empty: require('./img/star-empty.png')
};
